import React from 'react';
import PropTypes from 'prop-types';
import { Chip } from '@mui/material';
import { EMAIL_CAMPAIGNS_STATUS } from '../../config/const.config';

const EmailCampaignLabel = ({ value }) => {
  const label = EMAIL_CAMPAIGNS_STATUS[value].label || 'Unknown';
  const color = EMAIL_CAMPAIGNS_STATUS[value].color || 'primary';

  return <Chip label={label} color={color} variant="filled" size="small" />;
};

EmailCampaignLabel.propTypes = {
  value: PropTypes.number.isRequired,
};

export default EmailCampaignLabel;
